export default __webpack_public_path__ + "static/media/18.5c1054e5.svg";